import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin";

import CustomerFormProductionEmbeddable from "@/views/modules/customer/embeddable/CustomerFormProductionEmbeddable";
import CustomerFormArchEmbeddable from "@/views/modules/customer/embeddable/CustomerFormArchEmbeddable";
import CustomerFormERPEmbeddable from "@/views/modules/customer/embeddable/CustomerFormERPEmbeddable";
import CustomerEntity from "@/model/entities/modules/customer/CustomerEntity";


export default {
    components: {CustomerFormProductionEmbeddable, CustomerFormArchEmbeddable,CustomerFormERPEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "customer",
            form: new CustomerEntity()
        }

    },
    /*created(){
        this.form =
    },*/
    methods: {


    }
}